import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-deletion',
    templateUrl: './deletion.component.html',
    styleUrls: ['./deletion.component.scss'],
    standalone: false
})
export class DeletionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
